import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Button, Layout, Logo } from 'ds';
import { ROOT_PATH } from 'routes';

import StepTitle from './StepTitle';

import { ReactComponent as AiAssistantIcon } from 'ds/ai-assistant.svg';

interface Props {}

const ServicesRequestConfirmation: React.FC<Props> = () => {
  const history = useHistory();
  const { isMobile } = useContext(media);

  if (isMobile) {
    return (
      <Layout
        flex
        height="100vh"
        background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
        align="center"
        position="relative"
        paddingX={24}
      >
        <Layout gap={12} flex>
          <AiAssistantIcon style={{ flexShrink: 0 }} width={40} height={40} />
          <Layout position="relative" top={-8}>
            <StepTitle>Thanks! I’ll reach out soon.</StepTitle>
          </Layout>
        </Layout>
        <Layout position="absolute" top={40} left={40}>
          <Logo color="blue-500" size="sm" />
        </Layout>
        <Layout position="absolute" top={40} right={40}>
          <Button
            data-cy="exit-button"
            size="xs"
            type="secondary"
            text="Exit"
            onClick={() => history.push(ROOT_PATH)}
          />
        </Layout>
      </Layout>
    );
  }

  return (
    <Layout
      flex
      height="100vh"
      background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
      align="center"
      position="relative"
      paddingX={80}
    >
      <Layout>
        <StepTitle>Thanks! I’ll reach out soon.</StepTitle>
      </Layout>
      <Layout position="absolute" top={40} left={40}>
        <Logo color="blue-500" />
      </Layout>
      <Layout position="absolute" top={40} right={40}>
        <Button
          data-cy="exit-button-desktop"
          size="xs"
          type="secondary"
          text="Exit"
          onClick={() => history.push(ROOT_PATH)}
        />
      </Layout>
    </Layout>
  );
};

export default ServicesRequestConfirmation;
